/**
 * Iraq Provinces Constants
 * Contains detailed province/state data for Iraq without coordinates
 */

export interface ProvinceList {
    countryCode: string;
    isoCode: string;
    name: string;
}

export interface City {
    countryCode: string;
    name: string;
    stateCode: string;
    ProvinceCode: string;
}

export const PROVINCESLIST: ProvinceList[] = [
    { countryCode: 'IQ', isoCode: 'IQ-AN', name: 'Anbar' },
    { countryCode: 'IQ', isoCode: 'IQ-BA', name: 'Babylon' },
    { countryCode: 'IQ', isoCode: 'IQ-BG', name: 'Baghdad Karkh' },
    { countryCode: 'IQ', isoCode: 'IQ-BD', name: 'Baghdad Rusafa' },
    { countryCode: 'IQ', isoCode: 'IQ-BS', name: 'Basra' },
    { countryCode: 'IQ', isoCode: 'IQ-DQ', name: 'Dhi Qar' },
    { countryCode: 'IQ', isoCode: 'IQ-QA', name: 'Diwaniyah' },
    { countryCode: 'IQ', isoCode: 'IQ-DY', name: 'Diyala' },
    { countryCode: 'IQ', isoCode: 'IQ-DA', name: 'Dohuk' },
    { countryCode: 'IQ', isoCode: 'IQ-AR', name: 'Erbil' },
    { countryCode: 'IQ', isoCode: 'IQ-KA', name: 'Karbala' },
    { countryCode: 'IQ', isoCode: 'IQ-KK', name: 'Kirkuk' },
    { countryCode: 'IQ', isoCode: 'IQ-MA', name: 'Maysan' },
    { countryCode: 'IQ', isoCode: 'IQ-MU', name: 'Muthanna' },
    { countryCode: 'IQ', isoCode: 'IQ-NA', name: 'Najaf' },
    { countryCode: 'IQ', isoCode: 'IQ-NN', name: 'Nineveh' },
    { countryCode: 'IQ', isoCode: 'IQ-SD', name: 'Salah Al Din' },
    { countryCode: 'IQ', isoCode: 'IQ-SU', name: 'Sulaymaniyah' },
    { countryCode: 'IQ', isoCode: 'IQ-WA', name: 'Wasit' },
    { countryCode: 'IQ', isoCode: 'IQ-HA', name: 'Halabja' },
];

export const CITIESLIST: City[] = [
    //Anbar
    { countryCode: 'IQ', name: 'Ramadi', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Falluja', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: "Qa'aim", stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Heet', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Zikhekha', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Haditha', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Habbaniyah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Khalidiya', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Waleed', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Sagirah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Rutbah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Akashat', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Baghdadi', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Karabailah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Kabisa', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Nukhayb', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Naeimia', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Sijar', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Rahalia', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Sakra', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Jiba', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Hamiria', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Jazira', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Ramana', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Hibaria', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Kasra', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Saqlawia', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Obeidi', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Aana', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Rawa', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Amiriya', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Braunah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Karma', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Huqlania', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Tharthar', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Zawia', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Riyhana', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Furat', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Mohammadi', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Hasybah', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Sharqiya', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Arar', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Al Boasaf', stateCode: 'IQ-AN', ProvinceCode: 'AN' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-AN', ProvinceCode: 'AN' },

    //Babylon
    { countryCode: 'IQ', name: 'Al Qasim', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Musayib', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Al-Mudhatia', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Hilla', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Mhaweel', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Al Iskandaria', stateCode: 'IQ-BA', ProvinceCode: 'BA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-BA', ProvinceCode: 'BA' },

    //Baghdad Karkh
    { countryCode: 'IQ', name: 'Haifa Street', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Salihia', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Karada Mariam', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Green Zone', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Harthiya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Mansour', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Qadisiyah', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Iskan', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Yarmouk', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Amreya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Khadra Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Jamea Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Adel Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Ghazaliya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Jihad Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Amel Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Saydiya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Dwra', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Bayaa', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Shurta Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Kadhimiya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Atefiyah', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Shoulla', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Hurya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Dwlaey', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Slam', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Aweirij', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Sweib', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Mahmudiyah', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Abu Ghraib', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Taji', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Tarmya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Toubji', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Ali Al-Saleh', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Fourth Police Intersection', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Rasheed Subdistrict', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Latifiya', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al-Alaawi', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Turath Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Maalef ', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Shorta Alkhamsa', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Al Ealam Neighborhood', stateCode: 'IQ-BG', ProvinceCode: 'BG' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-BG', ProvinceCode: 'BG' },

    //Bagadad Rufasa
    { countryCode: 'IQ', name: 'Sinak', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Rashid Street', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Shorja', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Khilani', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Abu Nawas', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Bataween', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Sadoun Street', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Sheikh Omar', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Bab Al Moazam', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Medical City', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Palestine Street', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Mohandeseen', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Neighborhood July 14', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Idrissi', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Adhamiya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Waziriya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Maghreb Street', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Qahira Neighborhood', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Kryeaat', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Sbe Abkar', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Benook', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Awr', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Shaab', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Slykh', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Sadr City', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Habebya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Zayouna', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Ghadeer', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Baghdad Al Jadeeda', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Mashtal', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Kamalya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Obeidi', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Fadhiliyah', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Karrada', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Jadriya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Arasat Al Hindia', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Camp Sarah', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Zafaraniya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Rashid Camp', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Rustamiyah', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Baladiat', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Husainia', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al Thaalba', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Basmaya', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Hay Al-Wahda', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Hay Al-Naser', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Hay Tunis', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Al-Kifah', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Gumira', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Diyala Bridge', stateCode: 'IQ-BD', ProvinceCode: 'BD' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-BD', ProvinceCode: 'BD' },

    //Basra
    { countryCode: 'IQ', name: 'Al Bikr Walahrar', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Resala Neighborhood', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Kufaat Neighborhood', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Khadhraa', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Ashar', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Door Al Naft', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Buradhieia', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Minawi Pasha', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Gomhoria Neighborhood', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Tahsinia', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Abbasiyah', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Abla', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Jazayir Neighborhood', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Karmat Ali', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Ma`qal ', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: '5 Mile', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Briha', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Hakimia', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Jameiat', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Tawisa', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Qibla', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Nujaibiya', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Muwafaqiyah', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Asmailya', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Jubaila', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Andalus', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Talee`a', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Arabian Gulf', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Jazeera', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Qasim', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Wahda', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Rafidain', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Sahat', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Zubayr', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Faw', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al-Deir District', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Hay Al-Hussein', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: '14th of July Street', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al-Mutaiha', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Umm Qasr', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Shatt Al-Arab District', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al-Qa’im', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al-Junaina', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al-Madinah District', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Yaseen Khreibot', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Kzaizah', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Mohandseen', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Hayaniyah ', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Ghadeer', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Abo Al Khaseeb', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Safwan', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Tanooma', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Al Mishraq', stateCode: 'IQ-BS', ProvinceCode: 'BS' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-BS', ProvinceCode: 'BS' },

    //Dhi Qar
    { countryCode: 'IQ', name: 'Qadhaa Alnasirya', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Batha', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Islah', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Sayed Dakhil', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Awr', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Shatra', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Gharraf', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Dwaya', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Rifaey', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Nasr', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Qalat Sakar', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Fjr', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Sooq Al Shywkh', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Aqeeqa', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Fadhliya', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Tar', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Karmat Bani Saeed', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Chebaysh', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Fuhood', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Al Manar', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-DQ', ProvinceCode: 'DQ' },

    //Diwaniyah
    { countryCode: 'IQ', name: 'Diwaniyah', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Sunnya', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Shafaia', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Daghara', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Shamiya', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Ghamas', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Muhannawiyah', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Salahiyah', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Afak', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Al Budair', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Sumer', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Nefer', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Al Hamza', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Sudair', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Shinafiyah', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Photographers Street', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Hay Ramadan', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Hay Al Jameiaa', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Hay Al Hadhara', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Hay Aljazaer', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Al Orouba', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Al Qadisiya', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Al Sader', stateCode: 'IQ-QA', ProvinceCode: 'QA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-QA', ProvinceCode: 'QA' },

    //Diyala
    { countryCode: 'IQ', name: 'Baquba', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Buhraz', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Khan Bani Saad', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Kanaan', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Al Abbara', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Muqdadiya', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Dali Abbas', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Baladrouz', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Mandali', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Khanaqin', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Jalawlaa', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Saadia', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Khalis', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Hibhib', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Al Azim', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Al Mansuria', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Al Ghalibia', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Al Kufry', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Qarah Taba', stateCode: 'IQ-DY', ProvinceCode: 'DY' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-DY', ProvinceCode: 'DY' },

    //Dohuk
    { countryCode: 'IQ', name: 'Zawaytah', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Mankish', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Sarsank', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Zakho', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Smail', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Amadiyah', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Bardarash', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Aqrah', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Shekhan', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Bamerni', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Deiralock', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Solaf', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Dohuk', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'KRO Street', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Domez', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Korek Roundabout', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Mobile Exchange Street', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Faida Subdistrict', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Hay Zozan', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'New Exchange Market', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Kasruk Subdistrict', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Dohuk Market', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Opposite the General Traffic Roundabout', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Main Street Market', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Anwar May Street', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Old Dollar Market', stateCode: 'IQ-DA', ProvinceCode: 'DA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-DA', ProvinceCode: 'DA' },

    //Erbil
    { countryCode: 'IQ', name: 'Quesnijq', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Suran', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Shaqlawa', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Juman', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Ayn Kawah', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Qalaat', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Rawanduz', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Shorash', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Iskan', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Mannara', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Tirawa', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Hay Al Arab', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Ronaki', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: '7 Nissan', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Golan', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Eskry Neighborhood', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Bakhtiari', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Wazidan', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Mohandiseen Neighborhood', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Muntakawh', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Sadeen Royal Tower', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Tablo Mall', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: '2sides Luwan Street', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Empire Residential Complex', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Al-Mudhafariyah', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Aram City Complex', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Park View Complex', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Nashtiman Market', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Bazari – Police Neighborhood', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Bahari', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Sultan Muzafar', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: '60 Street', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Alaa Street – 60 Street', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: '100 Street', stateCode: 'IQ-AR', ProvinceCode: 'AR' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-AR', ProvinceCode: 'AR' },

    //Karbala
    { countryCode: 'IQ', name: 'Aoun', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Al Hur', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Al Husseiniya', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Ain Tamr', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Rahhaliyah', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Touirij', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Algharbi', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Al Khayrat', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Ramadan', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Al-Naqeeb', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Al-Hussein', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Al-Baladiyah', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Al-Aamel', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Al-Jamaiyah Area', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Hay Al-Dhubbat', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Al-Mulhaq Martyrs', stateCode: 'IQ-KA', ProvinceCode: 'KA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-KA', ProvinceCode: 'KA' },

    //Kirkuk
    { countryCode: 'IQ', name: 'Al Baath', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Wasti', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Ghernata', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Nasr', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Askari', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Orouba', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Nour', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Shuhadaa', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Shorja', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Ahmed Agha', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Qalaa', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Amam Qasim', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Qwria', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Buriadi', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Mas', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Asra W Almafqudeen', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Muealimeen', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Dhubbat', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: '1 Huziran', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Khadraa', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Hawija', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Daquq', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al Debs', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al-Jumhuriya Street', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al-Quds Street', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al-Shaabi District', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Baghdad Street', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: '90 Street', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Atlas Street', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Al-Hasir Market', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Hay Al-Osra', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Hay Al-Mansour', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Teachers’ Neighborhood', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Rahim Awa', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Kalar', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Baghdad Road', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Hay Adan', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Qorya', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Hay Al-Mansour', stateCode: 'IQ-KK', ProvinceCode: 'KK' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-KK', ProvinceCode: 'KK' },

    //Maysan
    { countryCode: 'IQ', name: 'Alamara', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Kumet', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al khlaa', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Masharah', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Bani Hashim', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Ali Al Gharbi', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Ali Al Sharqi', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Almajar Al Kabir', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Khayr', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Adel', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Qalat Salih', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Uzair', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Maymuna', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Salam', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Sayed Ahmed Rifai', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Qadiriyah', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Saray', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Muhammadiya', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Sabanchiya', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Shabana', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'Al Dabysat', stateCode: 'IQ-MA', ProvinceCode: 'MA' },
    { countryCode: 'IQ', name: 'other', stateCode: 'IQ-MA', ProvinceCode: 'MA' },

    //Muthanna
    { countryCode: 'IQ', name: 'Samawah', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Suwayrah', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Rumaythah', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Hilal', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Najmi', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Majd', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Salman', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Busyyah', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Khader', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Daraji', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Warka', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Karama', stateCode: 'IQ-MU', ProvinceCode: 'MU' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-MU', ProvinceCode: 'MU' },

    //Najaf
    { countryCode: 'IQ', name: 'Al Haidariyah', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Shabakiyah', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Ridawiyah', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Kufa', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Abbasia', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Alhurya', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Manathirah', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al Hira', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Qadisiyah', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Mashkhab', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al Iskan', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Hay Al-Jami’a', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Near Madinat Al-Ilm School', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al-Ameer Neighborhood', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al-Rawan Street', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Opposite Najaf Chamber of Commerce', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al-Ishtiraki Neighborhood', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al-Ghadir Street', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Grand Market', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Al Hanana', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Hay Al Adala', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Hay Al Zahraa', stateCode: 'IQ-NA', ProvinceCode: 'NA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-NA', ProvinceCode: 'NA' },

    //Nineveh
    { countryCode: 'IQ', name: 'Mosul', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Muthanna', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Zuhour', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Jamiah', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Arabi', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Nujaifi', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Hadbaa', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Nabi Younis', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Sina`a', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Shoura', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Qayyarah', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Basheeqa', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Badush', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Makhmour', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Bartala', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Sheikhan', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Talkif', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Talafar', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Fayda', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Al Qwosh', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Rabiaa', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Zamar', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Sinjar', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Baaj', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Qairawan', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Hadar', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Hammam Al Aleel', stateCode: 'IQ-NN', ProvinceCode: 'NN' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-NN', ProvinceCode: 'NN' },

    //Salah Al Din
    { countryCode: 'IQ', name: 'Samarra', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Tikrit', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Baiji', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Tuzkhermatu', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Dujail', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Sharqat', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Balad', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Dhuluiyah', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Al-Ilm', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Al-Dour', stateCode: 'IQ-SD', ProvinceCode: 'SD' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-SD', ProvinceCode: 'SD' },

    //Sulaymaniyah
    { countryCode: 'IQ', name: 'Bakra Joe', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Bazian', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Tangro', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Qara Dag', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Kani Shaitan', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Shara Zur', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Halabja', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Wara Mawa', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Sayed Sadiq', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Khurmal', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Penguin', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Sharbazeer', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Rania', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Dukan', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Darbandikan', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Kalar', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Kifri', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Chamchamal', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Khanaqin', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Tawi Ma Lik', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Salem Street', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Old Dollar Market', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Near Jawar Jra Directorate', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Sulaimaniya – 30 Street', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Sarchinar Market', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Dollar Market', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Saholaka City', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Raberin', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Sarchinar Main Road', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Saholaka City', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Ashti 200-Meter', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Rizgary', stateCode: 'IQ-SU', ProvinceCode: 'SU' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-SU', ProvinceCode: 'SU' },

    //Wasit
    { countryCode: 'IQ', name: 'Kut', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Sheikh Saad', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Al Swaira', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Zubaydiyah', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Shehaymiyah', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Al Aziziyah', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Taj Aldin', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Dabouni', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Numaniyah', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Al Ahrar', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Badra', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Zurbatiya', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Jassan', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Al Hay', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Muwaffaqiyah', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Bashaer', stateCode: 'IQ-WA', ProvinceCode: 'WA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-WA', ProvinceCode: 'WA' },

    //Halabja
    { countryCode: 'IQ', name: 'Halabja', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
    { countryCode: 'IQ', name: 'Khurmal', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
    { countryCode: 'IQ', name: 'Byara', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
    { countryCode: 'IQ', name: 'Tawea', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
    { countryCode: 'IQ', name: 'Jwargan', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
    { countryCode: 'IQ', name: 'Other', stateCode: 'IQ-HA', ProvinceCode: 'HA' },
];

/**
 * Get province by ISO code
 * @param isoCode - ISO code of the province (e.g., "IQ-AN")
 * @returns Province object or undefined if not found
 */

export const getProvinces = (CountryCode: string): ProvinceList[] => {
    return PROVINCESLIST.filter((province) => province.countryCode === CountryCode);
};

export const getProvinceByIsoCode = (isoCode: string): ProvinceList | undefined => {
    return PROVINCESLIST.find((province) => province.isoCode === isoCode);
};

/**
 * Get province by name
 * @param name - Name of the province
 * @returns Province object or undefined if not found
 */
export const getProvinceByName = (name: string): ProvinceList | undefined => {
    return PROVINCESLIST.find((province) => province.name.toLowerCase() === name.toLowerCase());
};

/**
 * Get all province names
 * @returns Array of province names
 */
export const getProvinceNames = (): string[] => {
    return PROVINCESLIST.map((province) => province.name);
};

/**
 * Get cities by province code
 * @param isoCode - Province code (e.g., "AN", "BA", "BK")
 * @returns Array of cities in the specified province
 */
export const getCitiesByProvinceCode = (isoCode: string): City[] => {
    return CITIESLIST.filter((city) => city.stateCode === isoCode);
};

/**
 * Get cities by province name
 * @param provinceName - Name of the province (e.g., "Anbar", "Baghdad Karkh")
 * @returns Array of cities in the specified province
 */
export const getCitiesByProvinceName = (provinceName: string): City[] => {
    const province = getProvinceByName(provinceName);
    if (!province) return [];

    // Extract province code from ISO code (e.g., "IQ-AN" -> "AN")
    const provinceCode = province.isoCode.split('-')[1];
    return getCitiesByProvinceCode(provinceCode);
};

/**
 * Get city by name
 * @param cityName - Name of the city
 * @returns City object or undefined if not found
 */
export const getCityByName = (cityName: string): City | undefined => {
    return CITIESLIST.find((city) => city.name.toLowerCase() === cityName.toLowerCase());
};

/**
 * Get cities by city code (same as province cities)
 * @param stateCode - City code (e.g., "IQ-AN")
 * @returns Array of cities with the specified city code
 */
export const getCitiesBystateCode = (stateCode: string): City[] => {
    return CITIESLIST.filter((city) => city.stateCode === stateCode);
};

/**
 * Get all city names
 * @returns Array of all city names
 */
export const getAllCityNames = (): string[] => {
    return CITIESLIST.map((city) => city.name);
};

/**
 * Get all city names for a specific province
 * @param provinceCode - Province code (e.g., "AN", "BA")
 * @returns Array of city names in the specified province
 */
export const getCityNamesByProvinceCode = (provinceCode: string): string[] => {
    return getCitiesByProvinceCode(provinceCode).map((city) => city.name);
};

/**
 * Search cities by name (partial match)
 * @param searchTerm - Search term to match against city names
 * @returns Array of cities that match the search term
 */
export const searchCitiesByName = (searchTerm: string): City[] => {
    const lowerSearchTerm = searchTerm.toLowerCase();
    return CITIESLIST.filter((city) => city.name.toLowerCase().includes(lowerSearchTerm));
};
